export default __webpack_public_path__ + "static/media/icon_mail.5be61cea.svg";